module.exports = __webpack_public_path__ + "static/hed-section-5-img-f88df6d77aa96b9390d22c8e2bc99453.png";